import { Injectable, inject } from '@angular/core';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { RoleModel } from '../role.model';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { AppTextService } from '@fi-app/shared/app-text';
import { FiStateService } from '@fi-app/shared/fi-state-proxy/fi-state.proxy.service';
import { ExtendSharingService } from '@fi-app/components/extend-sharing/extend-sharing.service';
import { ObjectTypes } from '@fi-app/shared/types/object-type';

@Injectable()
export class FiRoleActionHelperService {
    private appTextService = inject(AppTextService);
    private fiStateService = inject(FiStateService);
    private extendSharingService = inject(ExtendSharingService);

    getListItemActions(): IItemsListAction2<RoleModel>[] {
        const actions: IItemsListAction2<RoleModel>[] = [
            {
                title: this.appTextService.get('role.relations'),
                onClick: (item) => {
                    this.fiStateService.go(FiStateNames.Role.RoleRelations, { Id: item.Id });
                },
            },
        ];

        if (this.extendSharingService.hasAccessToExtendSharing()) {
            actions.push({
                title: this.appTextService.get('sharing.extend_sharing_to'),
                onClick: (item) => {
                    this.extendSharingService.openExtendedSharing(item.Id, ObjectTypes.Role);
                },
            });
        }

        return actions;
    }

    getSelectedItemsActions(deleteSelectedRoles: () => void): Readonly<IItemsListAction2[]> {
        return [
            {
                title: this.appTextService.get('common.delete'),
                onClick: deleteSelectedRoles,
            },
        ];
    }
}
